// Libs
import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { default as Loadable } from "../../../components/_Shared/commonLoadable";

// Actions
import { showModal, closeModal } from "../../../actions/ui";
import { updateCustomBuildStore } from "../../module/store/customBuild";

// Components
import ModalWrapper from "../../../components/_Shared/ModalWrapper";
import { Button, Input, Select } from "../../spocketUI";

import "./StoreDetailsModal.css";

import iconJewelWatch from "../../images/icons-jewel-watch.svg";
import iconBathBeauty from "../../images/icons-bath-beauty.svg";
import iconToys from "../../images/icon-toys.svg";
import iconPets from "../../images/icons-pets.svg";
import iconAccessories from "../../images/icon-accessories.svg";
import iconKidBabies from "../../images/icons-kid-babies.svg";
import iconFootwear from "../../images/icons-footwear.svg";
import iconMenClothing from "../../images/icons-men-clothing.svg";
import iconWomenClothing from "../../images/icons-women-clothing.svg";
import iconSportOutdoor from "../../images/icons-sport-outdoor.svg";
import iconTechAccessories from "../../images/icons-tech-accessories.svg";
import iconGift from "../../images/icons-gift.svg";
import iconHomeGarden from "../../images/icons-home-garden.svg";
import iconAutomotive from "../../images/icon-automotive.svg";

const options = [
  {
    value: "Jewelry & Watches",
    label: "Jewelry & Watches",
    icon: <img src={iconJewelWatch} alt="Category" />
  },
  {
    value: "Men's Clothing",
    label: "Men's Clothing",
    icon: <img src={iconMenClothing} alt="Category" />
  },
  {
    value: "Bath & Beauty",
    label: "Bath & Beauty",
    icon: <img src={iconBathBeauty} alt="Category" />
  },
  { value: "Toys", label: "Toys", icon: <img src={iconToys} alt="Category" /> },
  { value: "Pets", label: "Pets", icon: <img src={iconPets} alt="Category" /> },
  {
    value: "Accessories",
    label: "Accessories",
    icon: <img src={iconAccessories} alt="Category" />
  },
  {
    value: "Kids & Babies",
    label: "Kids & Babies",
    icon: <img src={iconKidBabies} alt="Category" />
  },
  {
    value: "Footwear",
    label: "Footwear",
    icon: <img src={iconFootwear} alt="Category" />
  },
  {
    value: "Women's Clothing",
    label: "Women's Clothing",
    icon: <img src={iconWomenClothing} alt="Category" />
  },
  {
    value: "Sports & Outdoors",
    label: "Sports & Outdoors",
    icon: <img src={iconSportOutdoor} alt="Category" />
  },
  {
    value: "Tech Accessories",
    label: "Tech Accessories",
    icon: <img src={iconTechAccessories} alt="Category" />
  },
  {
    value: "Gifts",
    label: "Gifts",
    icon: <img src={iconGift} alt="Category" />
  },
  {
    value: "Home & Garden",
    label: "Home & Garden",
    icon: <img src={iconHomeGarden} alt="Category" />
  },
  {
    value: "Automotive",
    label: "Automotive",
    icon: <img src={iconAutomotive} alt="Category" />
  }
];

const StoreDetailsModal = ({
  showModal,
  isFetching,
  updateCustomBuildStore
}) => {
  const [storeName, setStoreName] = useState("");
  const [category, setCategory] = useState("");

  // Returns a new URL with no protocol (https:// or http://)
  const removeProtocolUrl = url => {
    return String(url).replace(/^(https?|http):\/\//, "");
  };

  const normalizeStoreUrl = url => {
    // It removes anything that is not a letter or number.
    const keepLettersAndNumbers = /[a-zA-Z0-9-]+/g;
    const copyUrl = removeProtocolUrl(url).match(keepLettersAndNumbers);

    if (copyUrl) {
      // Looking for myshopify to remove everything after that into the URL
      const myshopifyIndex = copyUrl.indexOf("myshopify");
      const index = myshopifyIndex > -1 ? myshopifyIndex : copyUrl.length;

      return copyUrl
        .slice(0, index)
        .join("-")
        .toLowerCase();
    } else {
      return "";
    }
  };
  return (
    <ModalWrapper
      size="small"
      className="StoreDetailsModal__container"
      backdropClassName="StoreDetailsModal__backdrop"
    >
      <Loadable active={isFetching}>
        <ModalWrapper.Header>
          <div className="StoreDetailsModal__title">Store Details</div>
        </ModalWrapper.Header>

        <ModalWrapper.Body>
          <div className="StoreDetailsModal__label">
            <div>Store name</div> <span>Required</span>
          </div>
          <Input
            value={storeName}
            placeholder="Enter your store name…"
            onChange={e => setStoreName(normalizeStoreUrl(e.target.value))}
            variant="big"
          />
          <div className="StoreDetailsModal__details">
            <div>
              This will be your store name and it will be followed by the URL
            </div>
            <span>yourstore.myshopify.com </span>
          </div>

          <div className="StoreDetailsModal__label">
            <div>What products do you want to sell?</div> <span>Required</span>
          </div>

          <div className="StoreDetailsModal__category">
            <Select
              menuTitle="Categories"
              options={options}
              onChange={e => setCategory(e.value)}
              placeholder="Select one category……"
            />
          </div>
          <div className="StoreDetailsModal__details">
            <div>
              This will help us to create the best look and feel of your store,
              please select one category.
            </div>
          </div>
          <div className="StoreDetailsModal__footer">
            <Button
              variant="primaryBig"
              onClick={() =>
                updateCustomBuildStore({
                  uid: storeName,
                  category: category
                })
              }
              disabled={category === "" || storeName === ""}
            >
              Get my customized store NOW
            </Button>
          </div>
        </ModalWrapper.Body>
      </Loadable>
    </ModalWrapper>
  );
};

function mapStateToProps(state) {
  return {
    isFetching: state.store.customBuildStore.isFetching
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { showModal, updateCustomBuildStore, closeModal },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreDetailsModal);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/modalConductor/StoreDetailsModal.js